import {
  GET_LAST_INVOICES,
  GET_LAST_INVOICES_SUCCESS,
  GET_OVERVIEW,
  GET_OVERVIEW_SUCCESS
} from "../constants/Dashboards";

export const getOverview = () => {
  return {
    type: GET_OVERVIEW
  }
}

export const getOverviewSuccess = (data) => {
  return {
    type: GET_OVERVIEW_SUCCESS,
    data: data
  }
}

export const getLastInvoices = (per_page) => ({
  type: GET_LAST_INVOICES,
  per_page,
});

export const getLastInvoicesSuccess = (invoices) => ({
  type: GET_LAST_INVOICES_SUCCESS,
  invoices,
})

